// react documenation used: https://react.dev/learn
// ReactRouter documentation used : https://reactrouter.com/web/guides/quick-start
import React from "react";
import { useNavigate } from "react-router-dom";
import Nav from "../../layout/navBar/navBar";
import Recent from "../../layout/recentBar/recentBar";
import styles from "./discoverPage.module.css";

function DiscoverPage() {
  let navigate = useNavigate();
  const sharedRepositories = [
    { name: "APIs", icon: "🔗" },
    { name: "Interfaces", icon: "🔗" },
    { name: "Frontend", icon: "🔗" },
    { name: "Backend", icon: "🔗" },
    { name: "Webpages", icon: "🔗" },
    { name: "Application", icon: "🔗" },
    { name: "Mobile Apps", icon: "🔗" },
    { name: "Databases", icon: "🔗" },
    { name: "Embedded System", icon: "🔗" },
    { name: "Cloud", icon: "🔗" },
    { name: "All Repositories", icon: "🔗" },
  ];

  const navigateToCategory = (categoryName) => {
    navigate(`/categories/${categoryName}`);
  };

  return (
    <div>
      <Nav />
      <div className={styles.home}>
        <header className={styles.header}></header>
        <main className={styles.mainContent}>
          <section className={styles.recentlyAccessed}>
            <Recent />
          </section>

          <section className={styles.sharedRepositories}>
            <h2>Categories</h2>
            <div className={styles.reposContainer}>
              {sharedRepositories.map((repo, index) => (
                <div
                  key={index}
                  className={styles.repoCard}
                  onClick={() => navigateToCategory(repo.name)}
                  style={{ cursor: "pointer" }}
                >
                  {repo.icon} {repo.name}
                </div>
              ))}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default DiscoverPage;
